import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
    Alert,
    Container,
    Header as HeaderRS,
    Content,
    Footer,
    Sidebar as Side } from 'rsuite';
import { Header,
    Form,
    Button,
    Segment,
    Icon,
    Dropdown,
    Divider,
    List } from 'semantic-ui-react';
import { api } from '../../../services/api';

import Navbarr from '../../../components/Navbar';

import './styles.css';

export default function OwnProductViewEdit ({ sidebar: Sidebar}) {
    const { id } = useParams();
    const [prodStates, setProdStates] = useState({
        prod: {},
        formProd: {
            id: '',
            nome: '',
            proprios: []
        },
        prop: [],
        propOptions: [],
        currentProp: [],
        isLoadingData: true,
        isEditing: false
    });

    async function handleProp() {
        const currentProp = [];
        const propOptions = [];
        const prop = await fetchProp();
        prop.forEach(
            pp => {
                propOptions.push({key: pp['id'],
                                    text: pp['nome'],
                                    value: pp['id']});
            }
        );

        prodStates['prod']['proprios'].forEach(
            pp => {
                currentProp.push(pp['id']);
            }
        );

        handlePropChange(null, {value: currentProp});
        setProdStates(prevState => ({
            ...prevState,
            prop: prop,
            propOptions: propOptions,
        }));
    }

    async function fetchProp() {
        try {
            const data = await api.getOwnProducts();
            return data;
        } catch (err) {
            console.error("Falha ao obter produtos: ", err);
        }
    }

    const handleNomeChange = (e, {value}) => {
        setProdStates( prevState => ({
            ...prevState,
            formProd: {
                ...prevState['formProd'],
                nome: value
            }
        }));
    }

    const handlePropChange = (e, {value}) => {
        setProdStates((prevState) => ({
            ...prevState,
            currentProp: value
        }));
    }

    async function editProd () {
        setProdStates(prevState => ({
            ...prevState,
            isLoadingData: true
        }));

        await handleProp();

        setProdStates(prevState => ({
            ...prevState,
            isEditing: true,
            isLoadingData: false,
        }));
    }

    const cancelProdEdit = () => {
        setProdStates( prevState => ({
            ...prevState,
            formProd: prevState['prod'],
            isEditing: false
            }
        ));
    }

    async function handlePut() {
        try {
            setProdStates( prevState => ({
                ...prevState,
                isLoading: true,
            }));

            const proprios = [];

            prodStates['currentProp'].forEach(
                pp => proprios.push({'id':pp})
            );

            const data = await api.putCompProduct(prodStates['formProd']['id'],
                                            prodStates['formProd']['nome'],
                                            proprios);
            setProdStates( prevState => ({
                ...prevState,
                prod: data,
                formProd: {
                    ...prevState['formProd'],
                    ...data
                },
                isLoadingData: false,
                isEditing: false
            }));
            Alert.success('Produto atualizado com sucesso!');
        } catch (err) {
            Alert.error('Falha ao atualizar produto.');
            console.error('Falha ao atualizar produto: ', err);
            setProdStates( prevState => ({
                ...prevState,
                isLoadingData: false,
                isEditing: true
            }));
        }
    }

    useEffect(() => {
        async function fetchProd() {
            try {
                const data = await api.getCompProductsById(id);
                setProdStates( prevState => ({
                    ...prevState,
                    prod: data,
                    formProd: {
                        ...prevState['formProd'],
                        ...data
                    },
                    isLoadingData: false
                }));
            } catch (err) {
                console.error("Falha ao obter produto: ", err);
            }
        }

        fetchProd();
    },[id]);


    return (
        <Container>
            <Side style={{ flex: '0 0 auto', width: 'auto' }}>
                <Sidebar page={"comptlist"}></Sidebar>
            </Side>
            <Container>
                <HeaderRS>
                    <Navbarr></Navbarr>
                </HeaderRS>
                <Content style={{ backgroundColor: '#FAFAFA', padding: '5px'}}>
                    <div>
                        <Segment loading={prodStates['isLoadingData']}>
                            <Header as='h3' floated='left'>
                                Informações do Competidor
                            </Header>
                            {!prodStates['isEditing'] && <Button
                                primary
                                size="mini"
                                floated='right'
                                onClick={editProd}
                                >
                                    <div style={{ verticalAlign: 'middle', width: '70px', fontSize: '10px'}}>
                                        <Icon name='edit'/> Editar
                                    </div>
                            </Button>}

                            <Divider clearing />
                            <Form>
                                <Form.Group inline>
                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        <Form.Input
                                            readOnly={true}
                                            iconPosition='left'
                                            icon='key'
                                            fluid label='Identificador'
                                            placeholder='Identificador'
                                            value={prodStates['formProd'] ? prodStates['formProd']['id']: ""}
                                            />

                                        <Form.Input
                                            readOnly={!prodStates['isEditing']}
                                            iconPosition='left'
                                            icon='coffee'
                                            fluid label='Nome'
                                            placeholder='Nome'
                                            value={prodStates['formProd'] ? prodStates['formProd']['nome']: ""}
                                            onChange={handleNomeChange}
                                        />
                                    </Form.Group>

                                    {/* Dropdown proprios*/}
                                    {prodStates['formProd'] && prodStates['isEditing'] &&
                                        <Form.Group inline style={{marginBottom: '4px'}}>
                                            <label>proprios</label>
                                        </Form.Group>
                                    }
                                    {prodStates['formProd'] && prodStates['isEditing'] &&
                                        <Form.Group inline>
                                            <Dropdown
                                                disabled={!prodStates['isEditing']}
                                                options={prodStates['propOptions']}
                                                placeholder='Escolha proprios'
                                                search
                                                selection
                                                fluid
                                                multiple
                                                value={prodStates['currentProp']}
                                                onChange={handlePropChange}
                                            />
                                        </Form.Group>
                                    }

                                    {prodStates['formProd'] && !prodStates['isEditing']
                                        &&
                                        <Header as='h4' dividing>
                                            <Header.Content>
                                                Produtos
                                            </Header.Content>
                                        </Header>
                                    }
                                    {prodStates['formProd'] && !prodStates['isEditing'] && <List divided relaxed style={{marginTop: '30px'}}>
                                        {prodStates['formProd']['proprios'].map((pp) => {
                                            return (
                                                <List.Item key={pp['id']}>
                                                    <List.Content>
                                                        <List.Header style={{fontSize: '13px'}}>
                                                            {pp['nome']}
                                                        </List.Header>
                                                        <List.Description style={{fontSize: '12px'}}>Identificador: {pp['id']}</List.Description>
                                                    </List.Content>
                                                </List.Item>
                                                )
                                            })
                                        }
                                    </List> }

                                    <Form.Group>
                                        {prodStates['isEditing'] && <Button
                                            style={{marginLeft: '7px', marginTop: '7px'}}
                                            primary
                                            type='submit'
                                            size="mini"
                                            floated='right'
                                            onClick={handlePut}
                                            >
                                                <div style={{ verticalAlign: 'middle', width: '70px', fontSize: '10px'}}>
                                                    <Icon name='save'/> Salvar
                                                </div>
                                        </Button>}
                                        {prodStates['isEditing'] && <Button
                                            style={{marginLeft: '7px', marginTop: '7px'}}
                                            color='red'
                                            size="mini"
                                            floated='right'
                                            onClick={cancelProdEdit}
                                            >
                                                <div style={{ verticalAlign: 'middle', width: '70px', fontSize: '10px'}}>
                                                    <Icon name='cancel'/> Cancelar
                                                </div>
                                        </Button>}
                                    </Form.Group>
                                </Form>
                        </Segment>
                    </div>
                </Content>
                <Footer></Footer>
            </Container>
        </Container>
    );
}
